import React from "react";

import DetailForm from '../Form/DetailForm';
import TextInputField from '../Form/TextInputField';
import TextAreaInputField from '../Form/TextAreaInputField';
import NumberInputField from '../Form/NumberInputField';
import PostalCodeInputField from '../Form/PostalCodeInputField';
import SelectInputField from '../Form/SelectInputField';
import StatusRadioInputField from '../Form/StatusRadioInputField';
import MailStatus from '../Form/MailStatus';
import Reachability from '../Form/Reachability';
import AgentHistoryOverlay from './AgentHistoryOverlay';

import ContactFooter from './ContactFooter';
import OverviewFooter from './OverviewFooter';
import SubmitButton from '../Form/SubmitButton';

import { objectTypes } from '../LeadsList';
import { statusOptions } from '../LeadsEdit';

import EstimationView from '../Form/EstimationView';

import listingSchema from './schema/LeadRatingListing.json';
import customerSchema from './schema/LeadSaleCostumer.json';
import remarksSchema from './schema/LeadRemarks.json';
import { useHasPropTech } from "../../utils/useHasPropTech";
import PropTechSelectField from "../PropTechs/PropTechSelectField";

export default props => {
    const hasPropTech = useHasPropTech(props.record);

    return (
        <div className="flex row">
            <div className="flex-item">
                <DetailForm
                    formLabel="Übersicht"
                    boxClassName="overview"
                    validationSchema={listingSchema}
                    {...props}
                    noEditMode={hasPropTech}
                >
                    <SelectInputField source="listing.objectType" label="Objekt" options={objectTypes} />
                    <PostalCodeInputField source="listing.postalCode" label="Postleitzahl" />
                    <TextInputField source="listing.street" label="Straße" />
                    <NumberInputField source="listing.rooms" label="Zimmeranzahl" />
                    <NumberInputField source="listing.area" label="Größe in m&sup2;" />
                    <StatusRadioInputField source="listing.status" label="Status der Bewertung" options={statusOptions} />
                    <OverviewFooter />
                </DetailForm>
                <DetailForm
                    formLabel="Kontaktdaten"
                    boxClassName="contact"
                    validationSchema={customerSchema}
                    {...props}
                    noEditMode={hasPropTech}
                >
                    <TextInputField source="customer.firstName" label="Vorname" />
                    <TextInputField source="customer.lastName" label="Nachname" />
                    <TextInputField source="customer.email" label="E-Mail-Adresse" />
                    <MailStatus source="customer.verified" label="E-Mail bestätigt" />
                    <TextInputField source="customer.phone" label="Telefonnummer" />
                    <TextInputField source="customer.additionalPhone" label="Weitere Telefonnummer" />
                    <Reachability source="customer.reachability" label="Erreichbarkeit" />
                    <ContactFooter />
                </DetailForm>
            </div>
            <div className="flex-item">
                <DetailForm
                    formLabel="Makler zuweisen"
                    boxClassName="assign"
                    noEditMode
                    overlay={<AgentHistoryOverlay />}
                    {...props}
                >
                    <PropTechSelectField source="propTechDetails.propTech" label="Prop Tech" resource="proptechs" />
                    <SelectInputField source="agentDetails.agent" label="Vertriebsmitarbeiter" options={{}} />
                    <SelectInputField source="salesUser" label="Stadt" options={{}} />
                    <SubmitButton />
                </DetailForm>
                <DetailForm
                    formLabel="Ermittelter Durchschnittswert"
                    boxClassName=""
                    noEditMode
                    {...props}
                >
                   <EstimationView />
                </DetailForm>
                <DetailForm
                    formLabel="Sonstige Anmerkungen"
                    boxClassName=""
                    noEditMode
                    validationSchema={remarksSchema}
                    {...props}
                >
                    <TextAreaInputField source="remarks" label="Notizen" />
                    <SubmitButton />
                </DetailForm>
            </div>
        </div>
    );
}